import { Notyf } from 'notyf';
import solver from 'solver-utilities';

/**
 * Info notification
 * https://github.com/caroso1222/notyf
 * @param {string} message - Message to display to user
 * @param {object} options - Notyf options
 * @param {boolean} stealth - Goes straight to returning options and UI notification
 * @return {object} options
 */
export const info = function (
  message,
  options = {
    duration: parseInt(solver.frontend.getCSSVariable('--notification-duration')),
    position: {
      x: solver.frontend.getCSSVariable('--notification-x-position'),
      y: solver.frontend.getCSSVariable('--notification-y-position')
    },
    types: [
      {
        type: 'info',
        icon: false
      }
    ]
  },
  stealth = false
) {
  if (stealth) return options;
  const notyf = new Notyf(options);

  notyf.open({
    type: 'info',
    className: 'notification notification--info',
    message: '<span class="material-symbols-outlined">info</span> ' + message
  });

  return options;
};

/**
 * Success notification
 * https://github.com/caroso1222/notyf
 * @param {string} message - Message to display to user
 * @param {object} options - Notyf options
 * @param {boolean} stealth - Goes straight to returning options and UI notification
 * @return {object} options
 */
export const success = function (
  message,
  options = {
    duration: parseInt(solver.frontend.getCSSVariable('--notification-duration')),
    position: {
      x: solver.frontend.getCSSVariable('--notification-x-position'),
      y: solver.frontend.getCSSVariable('--notification-y-position')
    },
    types: [
      {
        type: 'success',
        icon: false
      }
    ]
  },
  stealth = false
) {
  if (stealth) return options;
  const notyf = new Notyf(options);

  notyf.open({
    duration: parseInt(solver.frontend.getCSSVariable('--notification-duration')),
    type: 'success',
    className: 'notification notification--success',
    message: '<span class="material-symbols-outlined">check_circle</span> ' + message
  });

  return options;
};

/**
 * Warning notification
 * https://github.com/caroso1222/notyf
 * @param {string} message - Message to display to user
 * @param {object} options - Notyf options
 * @param {boolean} stealth - Goes straight to returning options and UI notification
 * @return {object} options
 */
export const warning = function (
  message,
  options = {
    duration: parseInt(solver.frontend.getCSSVariable('--notification-duration')),
    position: {
      x: solver.frontend.getCSSVariable('--notification-x-position'),
      y: solver.frontend.getCSSVariable('--notification-y-position')
    },
    types: [
      {
        type: 'warning',
        icon: false
      }
    ]
  },
  stealth = false
) {
  if (stealth) return options;
  const notyf = new Notyf(options);

  notyf.open({
    duration: parseInt(solver.frontend.getCSSVariable('--notification-duration')),
    type: 'warning',
    className: 'notification notification--warning',
    message: '<span class="material-symbols-outlined">warning</span> ' + message
  });

  return options;
};

/**
 * Error notification
 * https://github.com/caroso1222/notyf
 * @param {string} message - Message to display to user
 * @param {object} options - Notyf options
 * @param {boolean} stealth - Goes straight to returning options and UI notification
 * @return {object} options
 */
export const error = function (
  message,
  options = {
    duration: parseInt(solver.frontend.getCSSVariable('--notification-duration')),
    position: {
      x: solver.frontend.getCSSVariable('--notification-x-position'),
      y: solver.frontend.getCSSVariable('--notification-y-position')
    },
    types: [
      {
        type: 'error',
        icon: false
      }
    ]
  },
  stealth = false
) {
  if (stealth) return options;
  const notyf = new Notyf(options);

  notyf.open({
    duration: parseInt(solver.frontend.getCSSVariable('--notification-duration')),
    type: 'error',
    className: 'notification notification--error',
    message: '<span class="material-symbols-outlined">error</span> ' + message
  });

  return options;
};

export const notification = function () {
  window.Solver.notification = {
    info,
    success,
    warning,
    error
  };
};
